function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowsDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cfcfcf"
    },
    fillRule: "evenodd",
    d: "M4 0l4.001 4.999h-8L4 0zm0 13.999l-3.999-5h8l-4.001 5z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsDisabled);
export default __webpack_public_path__ + "static/media/arrows_disabled.b0826aa4266d0f9b8ca547ecece18f71.svg";
export { ForwardRef as ReactComponent };